import { render, staticRenderFns } from "./approbation.vue?vue&type=template&id=b07a0ac4&"
import script from "./approbation.vue?vue&type=script&lang=js&"
export * from "./approbation.vue?vue&type=script&lang=js&"
import style0 from "./approbation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports